// extracted by mini-css-extract-plugin
module.exports = {"page":"login_page__Kmqja","skeleton_animate":"login_skeleton_animate__BiOtr","loading-roller":"login_loading-roller__RnVoX"};